import React from "react"

import {CompanyType} from "../../../../../../../types/company"
import {ActionCode} from "../../../../../../../types/action"
import ApproveRejectReviseButtons from "../../../../../../../components/ApproveRejectReviseButtons"

function showTheseButtons(companyType: CompanyType, ticketActionCode: ActionCode, hasAttachedCo: boolean): boolean {
  const showIfActionCode: ActionCode[] = ['tm_submitted']
  // Returns false if attachedCo 
  return companyType === 'cm' && showIfActionCode.includes(ticketActionCode) && !hasAttachedCo
}

interface TmApproveRejectReviseButtonsProps {
  toggleApproveForm: () => void,
  toggleRejectForm: () => void,
  toggleReviseForm: () => void,
  companyType: CompanyType,
  ticketActionCode: ActionCode,
  hasAttachedCo: boolean
}

export default function TmApproveRejectReviseButtons(props: TmApproveRejectReviseButtonsProps) {
  return showTheseButtons(props.companyType, props.ticketActionCode, props.hasAttachedCo) ? (
    <ApproveRejectReviseButtons
      toggleApproveForm={props.toggleApproveForm}
      toggleRejectForm={props.toggleRejectForm}
      toggleReviseForm={props.toggleReviseForm}
    />
  ) : (<></>)
}
